(() => {
  if (window.qbcSearchInitialized) return;
  window.qbcSearchInitialized = true;
  let serial = 0;
  function initialize(root = document) {
    root.querySelectorAll('form[data-qbc-search]').forEach((form) => {
      if (form.dataset.qbcReady) return;
      form.dataset.qbcReady = 'true';
      const input = form.querySelector('[name="q"]');
      const popup = document.createElement('div');
      popup.className = 'qbc-search-popup';
      popup.hidden = true;
      const status = document.createElement('span');
      status.className = 'visually-hidden';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      form.append(popup, status);
      const id = `qbc-suggestions-${++serial}`;
      input.setAttribute('role', 'combobox');
      input.setAttribute('aria-autocomplete', 'list');
      input.setAttribute('aria-expanded', 'false');
      input.setAttribute('aria-controls', id);
      input.setAttribute('autocomplete', 'off');
      let timer, controller, generation = 0, active = -1;
      const options = () => [...popup.querySelectorAll('[role="option"]')];
      function close() {
        clearTimeout(timer);
        generation++;
        controller?.abort();
        popup.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
        active = -1;
      }
      function show() {
        popup.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }
      function fallback(message) {
        popup.replaceChildren();
        const list = document.createElement('div');
        list.id = id;
        list.setAttribute('role', 'listbox');
        list.setAttribute('aria-label', 'Search results');
        const link = document.createElement('a');
        const url = new URL(form.action, location.origin);
        url.search = new URLSearchParams({ q: input.value.trim(), type: 'product', 'options[prefix]': 'last' });
        link.href = url.href;
        link.className = 'qbc-search-all';
        link.textContent = 'View all search results →';
        link.setAttribute('role', 'option');
        link.setAttribute('aria-selected', 'false');
        link.tabIndex = -1;
        link.id = `${id}-0`;
        list.append(link);
        const note = document.createElement('p');
        note.className = 'qbc-search-note';
        note.textContent = message;
        popup.append(list, note);
        status.textContent = message;
        show();
      }
      async function search() {
        const query = input.value.trim();
        if (query.length < 2) return;
        const request = ++generation;
        controller?.abort();
        controller = new AbortController();
        status.textContent = 'Searching products…';
        const url = new URL(`${window.Shopify?.routes?.root || '/'}search/suggest`, location.origin);
        url.search = new URLSearchParams({
          q: query, section_id: 'qbc-predictive-search', 'resources[type]': 'product',
          'resources[limit]': '6', 'resources[options][unavailable_products]': 'last',
          'resources[options][fields]': 'title,product_type,variants.title,tag,variants.sku,variants.barcode'
        });
        try {
          const response = await fetch(url, { signal: controller.signal });
          if (!response.ok) throw new Error('Search unavailable');
          const html = await response.text();
          if (request !== generation || document.activeElement !== input) return;
          const results = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-qbc-results]');
          if (!results) throw new Error('Missing search section');
          popup.replaceChildren(results);
          popup.querySelector('[role="listbox"]').id = id;
          options().forEach((option, index) => { option.id = `${id}-${index}`; });
          active = -1;
          const count = popup.querySelector('[data-qbc-count]').dataset.qbcCount;
          status.textContent = `${count} product suggestions. Use the arrow keys to browse, or Enter to search.`;
          show();
        } catch (error) {
          if (error.name !== 'AbortError' && request === generation && document.activeElement === input) {
            fallback('Quick suggestions are unavailable. You can still search the full store.');
          }
        }
      }
      input.addEventListener('input', (event) => {
        close();
        status.textContent = '';
        if (input.value.trim().length >= 2) timer = setTimeout(search, 250);
      });
      input.addEventListener('compositionend', () => { close(); timer = setTimeout(search, 250); });
      input.addEventListener('focus', () => { if (input.value.trim().length >= 2) { close(); timer = setTimeout(search, 100); } });
      input.addEventListener('keydown', (event) => {
        if (event.isComposing) return;
        if (event.key === 'Escape' && !popup.hidden) { event.preventDefault(); event.stopPropagation(); close(); return; }
        if (popup.hidden) return;
        const links = options();
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          active = active < 0 ? (event.key === 'ArrowDown' ? 0 : links.length - 1) : (active + (event.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length;
          links.forEach((link, index) => link.setAttribute('aria-selected', String(index === active)));
          input.setAttribute('aria-activedescendant', links[active].id);
          links[active].scrollIntoView({ block: 'nearest' });
        } else if (event.key === 'Enter' && active >= 0) {
          event.preventDefault();
          links[active].click();
        } else if (event.key === 'Tab') close();
      });
      popup.addEventListener('mousedown', (event) => event.preventDefault());
      form.addEventListener('focusout', () => setTimeout(() => { if (!form.contains(document.activeElement)) close(); }, 0));
      document.addEventListener('pointerdown', (event) => { if (!form.contains(event.target)) close(); });
      form.addEventListener('submit', (event) => { if (!input.value.trim()) event.preventDefault(); close(); });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
